import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from "antd";
import GlobalStyles from './global'
import { themeCommon } from './common';


export const theme = {
  ...themeCommon({
    // add styles to override theme
  })
}

export const ThemeWrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        },
      }}
    >
      {children}
    </ConfigProvider>
  </ThemeProvider>
)